import { Injectable } from '@angular/core'
import cubejs, { CubejsApi, Query, ResultSet } from '@cubejs-client/core'

export type Cubjsversion = 'cubi'
export interface CubejsConfig {
  apiUrl: string
  version: Cubjsversion
}

@Injectable({
  providedIn: 'root',
})
export class CubejsService {
  /** CubJS BI API Reference */
  public cubi: CubejsApi

  private timeZone: string

  /**
   * Init with JWT Token
   * @param { string } token
   * @param { CubejsConfig[] } configs
   * @param { string } timeZone
   */
  public init(
    token: string,
    configs: CubejsConfig[],
    timeZone = 'Europe/Paris'
  ): void {
    this.timeZone = timeZone
    for (let i = 0; configs.length > i; i++) {
      const config = configs[i]
      this[config.version] = cubejs(token, {
        apiUrl: config.apiUrl,
      })
    }
  }

  /** Load cubi query */
  public async load(request: Query): Promise<ResultSet<any>> {
    const query = {
      ...request,
      timezone: this.timeZone,
    }
    return this.cubi?.load(query)
  }
}
